'use client';

import { AVATAR_CROP_MIN } from './constants';
import { FreeformCropStage } from './freeform-crop-stage';
import type { SelectionPixelsChangeHandler } from './types';

interface AvatarCropStageProps {
  imageSrc: string;
  rotation: number;
  onSelectionPixelsChange: SelectionPixelsChangeHandler;
}

export function AvatarCropStage({
  imageSrc,
  rotation,
  onSelectionPixelsChange,
}: AvatarCropStageProps): React.JSX.Element {
  return (
    <FreeformCropStage
      imageSrc={imageSrc}
      rotation={rotation}
      mode="avatar"
      aspect={1}
      minWidth={AVATAR_CROP_MIN}
      rounded
      onSelectionPixelsChange={onSelectionPixelsChange}
    />
  );
}
